// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonFavorites_root__2vEcn","active":"ButtonFavorites_active__VWNsE","yellow":"ButtonFavorites_yellow__JnsW_","red":"ButtonFavorites_red__Y9BKo"};